import { Component, OnInit } from '@angular/core';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { WorkflowsService } from '../../system/workflows/service/workflows.service';
import { AccountRequestService } from '../../auth/service/account-request.service';

@Component({
  selector: 'app-my-involved',
  templateUrl: './my-involved.component.html',
  styleUrls: ['./my-involved.component.scss']
})

export class MyInvolvedComponent implements OnInit {
  scrName: string = "myinvolved";
  accountRequestId: number;
  loadingWorkflows = false;
  loading: any[] = [];
  msg: MsgModel = {};
  workflows: any[] = [];
  states: any[] = [];
  show: { [key: string]: boolean } = {};

  constructor(private workflowsService: WorkflowsService, private accountRequestService: AccountRequestService) { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.getWorkflows();
  }

  getWorkflows() {
    this.loadingWorkflows = true;
    this.workflowsService.getMyWorkflows().subscribe({
      next: (res) => {
        this.workflows = res.workflows;
        if (this.workflows.length === 1) {
          this.show[this.workflows[0].NAME] = true;
        }
        this.workflows.forEach((workflow, index) => {
          this.getWorkflowStates(workflow.ID, index);
        });
      },
      error: (err) => {
        this.msg = { SUCCESS: false, MSG: 'Error retrieving Workflow.' };
      },
      complete: () => {
        this.loadingWorkflows = false;
      }
    });
  }

  getWorkflowStates(workflowID: number, workflowIndex: number) {
    this.loading[workflowID] = true;

    this.workflowsService.getOutboxStates(workflowID).subscribe({
      next: (res) => {
        if (res?.states) {
          this.states = JSON.parse(res.states)
          this.workflows[workflowIndex].states = this.cleanState(this.states);
        }
        else if (res.msg) {
          this.workflows[workflowIndex].states = [];
        }
      },
      error: (err) => {
        this.msg = { SUCCESS: false, MSG: 'Error retrieving WorkflowStates.' };
      },
      complete: () => {
        this.loading[workflowID] = false;
      }
    });
  }

  getWorkflowNodeCount(workflow: any): number {
    let count = 0;
    // Use forEach to loop through states
    if (workflow.states) {
      workflow.states.forEach((state: any) => {
        if (state.NODES) {
          count += state.NODES.length;
        }
      });
    }
    return count;
  }

  isLoading(id: number) {
    if (this.loading[id]) {
      return true;
    }
    return false;
  }

  cleanState(states: any[]): any[] {
    let createdBy = "---";
    let createdDate = "";
    let lastUpdatedBy = "---";
    let lastUpdatedDate = "";
    states.forEach(state => {
      state.NODES.forEach((node: {
        CREATED_DATE: string;
        NODE_HISTORIES: string | any[];
        lastestUpdatedDate: any;
        createdToolTip: string;
        updatedToolTip: string;
        regionName: string;
        NODE_COES: string | any[];
        NODE_REGIONS: string | any[];
        NODE_PROVISIONAL_SCHOOLS: string | any[];
        NODE_ACCOUNT_REQUESTS: string | any[];
        NODE_CREATORS: string | any[];
      }) => {

        createdDate = this.getTimeDifferenceinHours(new Date(node.CREATED_DATE));
        node.CREATED_DATE = this.simpleDateTime(node.CREATED_DATE);
        if (node.NODE_HISTORIES && node.NODE_HISTORIES.length > 0) {
          const latestHistory = node.NODE_HISTORIES[node.NODE_HISTORIES.length - 1];
          lastUpdatedDate = this.getTimeDifferenceinHours(new Date(latestHistory.CREATED_DATE));
          latestHistory.CREATED_DATE = this.simpleDateTime(latestHistory.CREATED_DATE);
          node.lastestUpdatedDate = latestHistory.CREATED_DATE;
          if (latestHistory.LOGIN_DETAILS)
            lastUpdatedBy = latestHistory.LOGIN_DETAILS?.PERSON?.FIRST_NAME + " " + latestHistory?.LOGIN_DETAILS?.PERSON?.LAST_NAME + " (" + latestHistory?.LOGIN_DETAILS?.USER_ID + ")";
        }
        if (node.NODE_ACCOUNT_REQUESTS && node.NODE_ACCOUNT_REQUESTS.length > 0 && node.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.ID) {
          this.accountRequestId = node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.ID;
          this.accountRequestService.showDetails(this.accountRequestId).subscribe({
            next: (res) => {
              node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME = res.accountRequest.FIRST_NAME;
              node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.LAST_NAME = res.accountRequest.LAST_NAME;
              node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.EMAIL_ADDRESS = res.accountRequest.EMAIL_ADDRESS;
            },
            error: (err) => {
              this.msg = { SUCCESS: false, MSG: 'Error retrieving accountRequestService showDetails.' };
            },
            complete: () => {
              // Display results
            }
          });
        }
        if (node.NODE_CREATORS && node.NODE_CREATORS.length > 0)
        {
          createdBy = node.NODE_CREATORS[0]?.LOGIN_DETAILS?.PERSON?.FIRST_NAME + " " + node.NODE_CREATORS[0]?.LOGIN_DETAILS?.PERSON?.LAST_NAME + " (" + node.NODE_CREATORS[0]?.LOGIN_DETAILS?.USER_ID + ")";
        }
        if (createdDate != "")
        {
          node.createdToolTip = "Created " + createdDate + " ago\n Created by: " + createdBy
        }
        if (lastUpdatedDate != "")
        {
          node.updatedToolTip = "Last Updated " + lastUpdatedDate + " ago\n Last Updated by: " + lastUpdatedBy
        }
        if (node.NODE_REGIONS && node.NODE_REGIONS.length > 0)
        {
          node.regionName = node.NODE_REGIONS[0].REGION.NAME;
        }
      });
    });
    return states;
  }

  getTimeDifferenceinHours(targetDate: Date): string {
    const now = new Date();
    const differenceInMilliseconds = now.getTime() - targetDate.getTime();
    const days = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    const remainingMilliseconds = differenceInMilliseconds % (1000 * 60 * 60 * 24);
    const hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60));
    if (hours == 0)
      return `${days} days, ${hours} hour`;
    else
      return `${days} days, ${hours} hours`;
  }

  simpleDateTime(date: string): string {
    // Implement your date formatting logic here
    return date; // Replace with actual formatted date
  }

  toggleShow(obj: any) {
    obj.SHOW = !obj.SHOW;
  }

  expandAll(): void {
    this.workflows.forEach(workflow => {
      workflow.SHOW = true;
      if (workflow.states) {
        workflow.states.forEach((state: any) => {
          state.SHOW = true;
        });
      }
    });
  }

  collapseAll(): void {
    this.workflows.forEach(workflow => {
      workflow.SHOW = false;
      if (workflow.states) {
        workflow.states.forEach((state: any) => {
          state.SHOW = false;
        });
      }
    });
  }
}